import { IconButton } from '@material-ui/core';
import ImportIcon from '@material-ui/icons/Publish';
import { observer } from 'mobx-react';
import React from 'react';
import { useBooleanStateAgg } from '../mg/useStateAgg';
import { ImportDialog } from './internal/ImportDialog';

interface IImportButtonProps {
	path: string
	afterImport() : void
	className?: string
}

export const ImportButton = observer(function ImportButton(props: IImportButtonProps) {
	const openAgg = useBooleanStateAgg();
	const {path, afterImport: afterImport1, className} = props;
	function afterImport(success: boolean) {
		openAgg.falseHandler();
		if (success) afterImport1?.();
	}
	return <IconButton onClick={openAgg.trueHandler}>
		<ImportIcon className={className}/>
		{!openAgg.value ? null : <ImportDialog uploadPath={path} afterImport={afterImport}/>}
	</IconButton>;
});
